const accountProfileI18n = {
  "fr": {
    "title": "Mon compte",
    "email": "Email",
    "company": "Entreprise",
    "profile": {
      "title": "Mes informations d’expédition",
      "firstname": "Prénom",
      "name": "Nom",
      "phone": "Numéro de téléphone",
      "address": "Adresse postale",
      "postalCode": "Code postal",
      "city": "Ville",
      "save": "Enregistrer mes informations",
      "statusComplete": "Profil d’expédition complet",
      "statusIncomplete": "Profil d’expédition incomplet",
      "hint": "Merci de renseigner toutes vos informations d’expédition pour pouvoir finaliser vos ventes.",
      "edit": "Modifier mes informations"
    },
    "bank": {
      "title": "Coordonnées bancaires (IBAN)",
      "edit": "Modifier",
      "add": "Ajouter",
      "iban": "IBAN",
      "rgpd": "Conformité RGPD : l’IBAN est chiffré au repos. Vous pouvez le modifier à tout moment."
    },
    "form": {
      "owner": "Titulaire du compte (facultatif)",
      "iban": "IBAN",
      "helper": "Nous acceptons les IBAN de l’Espace SEPA.",
      "save": "Enregistrer",
      "cancel": "Annuler"
    },
    "logout": "Déconnexion",
    "errors": {
      "invalidIban": "IBAN invalide. Vérifiez le format et la clé (mod 97).",
      "saveFailed": "Impossible d’enregistrer l’IBAN.",
      "loadProfile": "Impossible de charger votre profil.",
      "profileSaveFailed": "Impossible d’enregistrer vos informations."
    },
    "messages": {
      "saved": "IBAN enregistré avec succès.",
      "copied": "IBAN copié (masqué)."
    },
    "profileMessages": {
      "saved": "Vos informations de profil ont été enregistrées."
    }
  },
  "en": {
    "title": "My account",
    "email": "Email",
    "company": "Company",
    "profile": {
      "title": "My shipping information",
      "firstname": "First name",
      "name": "Last name",
      "phone": "Phone number",
      "address": "Postal address",
      "postalCode": "Postal code",
      "city": "City",
      "save": "Save my information",
      "statusComplete": "Shipping profile complete",
      "statusIncomplete": "Shipping profile incomplete",
      "hint": "Please fill in all your shipping details to finalise your sales.",
      "edit": "Edit my information"
    },
    "bank": {
      "title": "Bank details (IBAN)",
      "edit": "Edit",
      "add": "Add",
      "iban": "IBAN",
      "rgpd": "GDPR compliance: IBAN is encrypted at rest. You can update it at any time."
    },
    "form": {
      "owner": "Account holder (optional)",
      "iban": "IBAN",
      "helper": "We accept IBANs from the SEPA area.",
      "save": "Save",
      "cancel": "Cancel"
    },
    "logout": "Log out",
    "errors": {
      "invalidIban": "Invalid IBAN. Check format and checksum (mod 97).",
      "saveFailed": "Unable to save IBAN.",
      "loadProfile": "Unable to load your profile.",
      "profileSaveFailed": "Unable to save your information."
    },
    "messages": {
      "saved": "IBAN saved successfully.",
      "copied": "IBAN copied (masked)."
    },
    "profileMessages": {
      "saved": "Your profile information has been saved."
    }
  },
  "pl": {
    "title": "Moje konto",
    "email": "Email",
    "company": "Firma",
    "profile": {
      "title": "Moje dane wysyłkowe",
      "firstname": "Imię",
      "name": "Nazwisko",
      "phone": "Numer telefonu",
      "address": "Adres pocztowy",
      "postalCode": "Kod pocztowy",
      "city": "Miasto",
      "save": "Zapisz dane",
      "statusComplete": "Profil wysyłkowy kompletny",
      "statusIncomplete": "Profil wysyłkowy niekompletny",
      "hint": "Uzupełnij wszystkie dane wysyłkowe, aby dokończyć sprzedaż.",
      "edit": "Edytuj dane"
    },
    "bank": {
      "title": "Dane bankowe (IBAN)",
      "edit": "Edytuj",
      "add": "Dodaj",
      "iban": "IBAN",
      "rgpd": "RODO: IBAN jest szyfrowany w spoczynku. Możesz go zmienić w każdej chwili."
    },
    "form": {
      "owner": "Właściciel konta (opcjonalnie)",
      "iban": "IBAN",
      "helper": "Akceptujemy IBAN-y z obszaru SEPA.",
      "save": "Zapisz",
      "cancel": "Anuluj"
    },
    "logout": "Wyloguj",
    "errors": {
      "invalidIban": "Nieprawidłowy IBAN. Sprawdź format i sumę kontrolną (mod 97).",
      "saveFailed": "Nie udało się zapisać IBAN.",
      "loadProfile": "Nie udało się wczytać profilu.",
      "profileSaveFailed": "Nie udało się zapisać danych."
    },
    "messages": {
      "saved": "IBAN zapisany pomyślnie.",
      "copied": "Skopiowano IBAN (zamaskowany)."
    },
    "profileMessages": {
      "saved": "Dane profilu zostały zapisane."
    }
  },
  "es": {
    "title": "Mi cuenta",
    "email": "Email",
    "company": "Empresa",
    "profile": {
      "title": "Mi información de envío",
      "firstname": "Nombre",
      "name": "Apellido",
      "phone": "Número de teléfono",
      "address": "Dirección postal",
      "postalCode": "Código postal",
      "city": "Ciudad",
      "save": "Guardar mi información",
      "statusComplete": "Perfil de envío completo",
      "statusIncomplete": "Perfil de envío incompleto",
      "hint": "Por favor, complete toda su información de envío para finalizar sus ventas.",
      "edit": "Editar mi información"
    },
    "bank": {
      "title": "Datos bancarios (IBAN)",
      "edit": "Editar",
      "add": "Añadir",
      "iban": "IBAN",
      "rgpd": "Cumplimiento RGPD: el IBAN está cifrado en reposo. Puede modificarlo en cualquier momento."
    },
    "form": {
      "owner": "Titular de la cuenta (opcional)",
      "iban": "IBAN",
      "helper": "Aceptamos IBAN del área SEPA.",
      "save": "Guardar",
      "cancel": "Cancelar"
    },
    "logout": "Cerrar sesión",
    "errors": {
      "invalidIban": "IBAN inválido. Compruebe el formato y el dígito de control (mod 97).",
      "saveFailed": "No se pudo guardar el IBAN.",
      "loadProfile": "No se pudo cargar su perfil.",
      "profileSaveFailed": "No se pudieron guardar sus datos."
    },
    "messages": {
      "saved": "IBAN guardado correctamente.",
      "copied": "IBAN copiado (oculto)."
    },
    "profileMessages": {
      "saved": "Su información de perfil ha sido guardada."
    }
  },
  "it": {
    "title": "Il mio account",
    "email": "Email",
    "company": "Società",
    "profile": {
      "title": "Le mie informazioni di spedizione",
      "firstname": "Nome",
      "name": "Cognome",
      "phone": "Numero di telefono",
      "address": "Indirizzo postale",
      "postalCode": "Codice postale",
      "city": "Città",
      "save": "Salva le mie informazioni",
      "statusComplete": "Profilo di spedizione completo",
      "statusIncomplete": "Profilo di spedizione incompleto",
      "hint": "Si prega di compilare tutti i dettagli di spedizione per finalizzare le vendite.",
      "edit": "Modifica le mie informazioni"
    },
    "bank": {
      "title": "Dati bancari (IBAN)",
      "edit": "Modifica",
      "add": "Aggiungi",
      "iban": "IBAN",
      "rgpd": "Conformità GDPR: IBAN è crittografato a riposo. Puoi aggiornarlo in qualsiasi momento."
    },
    "form": {
      "owner": "Titolare del conto (opzionale)",
      "iban": "IBAN",
      "helper": "Accettiamo IBAN dalla zona SEPA.",
      "save": "Salva",
      "cancel": "Annulla"
    },
    "logout": "Accedi",
    "errors": {
      "invalidIban": "IBAN non valido. Controllo formato e checksum (mod 97).",
      "saveFailed": "Incapace di salvare IBAN.",
      "loadProfile": "Non riesco a caricare il tuo profilo.",
      "profileSaveFailed": "Incapace di salvare le tue informazioni."
    },
    "messages": {
      "saved": "IBAN ha salvato con successo.",
      "copied": "IBAN copiato (mascherato)."
    },
    "profileMessages": {
      "saved": "Le informazioni sul tuo profilo sono state salvate."
    }
  },
  "de": {
    "title": "Mein Konto",
    "email": "E-Mail",
    "company": "Unternehmen",
    "profile": {
      "title": "Meine Versandinformationen",
      "firstname": "Vorname",
      "name": "Nachname",
      "phone": "Telefonnummer",
      "address": "Postanschrift",
      "postalCode": "Postleitzahl",
      "city": "Stadt",
      "save": "Speichern Sie meine Informationen",
      "statusComplete": "Versandprofil vollständig",
      "statusIncomplete": "Versandprofil unvollständig",
      "hint": "Bitte füllen Sie alle Ihre Versanddetails aus, um Ihren Verkauf abzuschließen.",
      "edit": "Bearbeiten meiner Informationen"
    },
    "bank": {
      "title": "Bankverbindung (IBAN)",
      "edit": "Edit",
      "add": "Addition",
      "iban": "IBAN",
      "rgpd": "DSGVO-Compliance: IBAN ist in Ruhe verschlüsselt. Sie können es jederzeit aktualisieren."
    },
    "form": {
      "owner": "Kontoinhaber (fakultativ)",
      "iban": "IBAN",
      "helper": "Wir akzeptieren IBANs aus dem SEPA-Bereich.",
      "save": "Sparen",
      "cancel": "Stornierung"
    },
    "logout": "Abmelden",
    "errors": {
      "invalidIban": "Ungültige IBAN. Prüfformat und Prüfsumme (mod 97).",
      "saveFailed": "IBAN kann nicht gespeichert werden.",
      "loadProfile": "Sie können Ihr Profil nicht laden.",
      "profileSaveFailed": "Sie können Ihre Informationen nicht speichern."
    },
    "messages": {
      "saved": "IBAN erfolgreich gerettet.",
      "copied": "IBAN kopiert (maskiert)."
    },
    "profileMessages": {
      "saved": "Ihre Profilinformationen wurden gespeichert."
    }
  },
  "pt": {
    "title": "A minha conta",
    "email": "E- mail",
    "company": "Empresa",
    "profile": {
      "title": "A minha informação de envio",
      "firstname": "Nome próprio",
      "name": "Sobrenome",
      "phone": "Número de telefone",
      "address": "Endereço postal",
      "postalCode": "Código postal",
      "city": "Cidade",
      "save": "Gravar a minha informação",
      "statusComplete": "Perfil de envio completo",
      "statusIncomplete": "Perfil de envio incompleto",
      "hint": "Por favor, preencha todos os seus detalhes de envio para finalizar suas vendas.",
      "edit": "Editar a minha informação"
    },
    "bank": {
      "title": "Dados bancários (IBAN)",
      "edit": "Editar",
      "add": "Adicionar",
      "iban": "IBAN",
      "rgpd": "Compliance GDPR: O IBAN está criptografado em repouso. Você pode atualizá-lo a qualquer momento."
    },
    "form": {
      "owner": "Titular da conta (facultativo)",
      "iban": "IBAN",
      "helper": "Aceitamos IBANs da área SEPA.",
      "save": "Gravar",
      "cancel": "Cancelar"
    },
    "logout": "Sair",
    "errors": {
      "invalidIban": "IBAN inválido. Verificar o formato e a soma de verificação (mod 97).",
      "saveFailed": "Não foi possível salvar o IBAN.",
      "loadProfile": "Não foi possível carregar o seu perfil.",
      "profileSaveFailed": "Não foi possível salvar suas informações."
    },
    "messages": {
      "saved": "IBAN salvo com sucesso.",
      "copied": "IBAN copiado (mascarado)."
    },
    "profileMessages": {
      "saved": "Suas informações de perfil foram salvas."
    }
  },
  "cs": {
    "title": "Můj účet",
    "email": "E-mail",
    "company": "Společnost",
    "profile": {
      "title": "Moje přepravní informace",
      "firstname": "Jméno",
      "name": "Jméno",
      "phone": "Číslo telefonu",
      "address": "Poštovní adresa",
      "postalCode": "PSČ",
      "city": "Město",
      "save": "Uložit mé informace",
      "statusComplete": "Přepravní profil kompletní",
      "statusIncomplete": "Přepravní profil neúplný",
      "hint": "Vyplňte prosím všechny údaje o přepravě a dokončete prodej.",
      "edit": "Upravit mé informace"
    },
    "bank": {
      "title": "Bankovní údaje (IBAN)",
      "edit": "Upravit",
      "add": "Přidat",
      "iban": "IBAN",
      "rgpd": "Dodržování GDPR: IBAN je v klidu zašifrován. Můžete to kdykoliv aktualizovat."
    },
    "form": {
      "owner": "Držitel účtu (nepovinné)",
      "iban": "IBAN",
      "helper": "Přijímáme IBANY z oblasti SEPA.",
      "save": "Uložit",
      "cancel": "Zrušit"
    },
    "logout": "Odhlásit se",
    "errors": {
      "invalidIban": "Neplatný IBAN. Zkontrolujte formát a kontrolní součet (mod 97).",
      "saveFailed": "Nelze uložit IBAN.",
      "loadProfile": "Nelze načíst váš profil.",
      "profileSaveFailed": "Nelze uložit vaše informace."
    },
    "messages": {
      "saved": "IBAN úspěšně uložil.",
      "copied": "IBAN zkopíroval (maskoval)."
    },
    "profileMessages": {
      "saved": "Vaše informace o profilu byly uloženy."
    }
  },
  "nl": {
    "title": "Mijn account",
    "email": "E-mail",
    "company": "Onderneming",
    "profile": {
      "title": "Mijn verzendinformatie",
      "firstname": "Voornaam",
      "name": "Achternaam",
      "phone": "Telefoonnummer",
      "address": "Postadres",
      "postalCode": "Postcode",
      "city": "Stad",
      "save": "Mijn informatie opslaan",
      "statusComplete": "Verzendprofiel voltooid",
      "statusIncomplete": "Verzendprofiel onvolledig",
      "hint": "Vul al uw verzendgegevens in om uw verkoop af te ronden.",
      "edit": "Mijn informatie bewerken"
    },
    "bank": {
      "title": "Bankgegevens (IBAN)",
      "edit": "Bewerken",
      "add": "Voeg toe",
      "iban": "IBAN",
      "rgpd": "Compliance AVG: IBAN wordt in rust versleuteld. Je kunt het altijd bijwerken."
    },
    "form": {
      "owner": "Rekeninghouder (facultatief)",
      "iban": "IBAN",
      "helper": "Wij accepteren IBAN's van het SEPA-gebied.",
      "save": "Opslaan",
      "cancel": "Annuleren"
    },
    "logout": "Afmelden",
    "errors": {
      "invalidIban": "Ongeldig IBAN. Controleer formaat en controlesom (mod 97).",
      "saveFailed": "Kon IBAN niet redden.",
      "loadProfile": "Kon uw profiel niet laden.",
      "profileSaveFailed": "Kon uw gegevens niet opslaan."
    },
    "messages": {
      "saved": "IBAN met succes gered.",
      "copied": "IBAN gekopieerd (gemaskerd)."
    },
    "profileMessages": {
      "saved": "Uw profielinformatie is opgeslagen."
    }
  }
};

export default accountProfileI18n;
